import React, { useEffect, useState } from 'react'
import { useRequest } from '../../../Context/RequestContext';

function SelectCategory({ className, name, onChange, value }) {
    const [categoriesOptions, setCategoriesOptions] = useState([]);
    const { Request } = useRequest();
    useEffect(() => {
        getSelectCategories();
    }, [])

    const getSelectCategories = () => {
        Request({ url: '/admin/select-categories' }).then((response) => {
            if (response.status === 200) {
                setCategoriesOptions(response.data);
            }
        })
    }

    const RenderChildrens = (category, padding = false) => {

        return (
            [...category.childrens_select].length ?
                <>
                    <optgroup key={Math.random()} label={category.name}> </optgroup>
                    <option selected={value == category.id} value={category.id}>{category.name}</option>
                    {[...category.childrens_select].map((children, i) => RenderChildrens(children, true))}

                </>
                : <option selected={value == category.id} key={Math.random()} value={category.id}>{category.name}</option>
        )
    }

    return (
        <div className={`form-group ${className} `}>
            <label htmlFor="category_id">دسته بندی</label>
            <select id='category_id' name={name} onChange={onChange} className='form-control'>
                <option value="">انتخاب کنید</option>
                {categoriesOptions.map((category) => {
                    return RenderChildrens(category)
                })}
            </select>
        </div>
    )
}

export default SelectCategory